import { render, staticRenderFns } from "./user_form.vue?vue&type=template&id=10e6ae55&scoped=true"
import script from "./user_form.vue?vue&type=script&lang=js"
export * from "./user_form.vue?vue&type=script&lang=js"
import style0 from "./user_form.vue?vue&type=style&index=0&id=10e6ae55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6ae55",
  null
  
)

/* custom blocks */
import block0 from "./user_form.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports